"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackAdClick = void 0;
const browser_plugin_ad_tracking_1 = require("@snowplow/browser-plugin-ad-tracking");
/**
 * Track trackAdClick event in Snowplow.
 * v.0.13.0;
 * @public
 *
 * @param trackAdClickData - Object that contains event properties described in the Ad click tracking document
 * (see https://docs.snowplow.io/docs/collecting-data/collecting-from-own-applications/javascript-trackers/browser-tracker/browser-tracker-v3-reference/tracking-events/#trackadclick ).
 *
 * @example
 * ```ts
 *
 * import {trackAdClick} from '@hc-frontend/third-party-snowplow';
 *
 * trackAdClick({
 * targetUrl: 'http://www.example.com',
 * clickId: '12243253',
 * costModel: 'cpm',
 * cost: 2.5,
 * bannerId: '23',
 * impressionOrder: '7',
 * advertiserId: '201',
 * campaignId: '12',
 * impressionId: 'c8514213-d397-4956-bc4c-fd2561090e85',
 * });
 * ```
 */
function trackAdClick(trackAdClickData, contexts) {
    const { targetUrl, clickId, costModel, cost, bannerId, impressionOrder, advertiserId, campaignId, impressionId, } = trackAdClickData;
    (0, browser_plugin_ad_tracking_1.trackAdClick)({
        targetUrl,
        clickId,
        costModel,
        cost,
        bannerId,
        zoneId: impressionOrder,
        advertiserId,
        campaignId,
        impressionId,
        context: contexts,
    });
}
exports.trackAdClick = trackAdClick;
//# sourceMappingURL=ad-click.js.map